import React, { useMemo } from 'react';
import { Alert, Box, Typography } from '@mui/material';
import { format } from 'date-fns';

interface TrialEndedBannerProps {
  trialEndDate?: string | Date;
}

export const TrialEndedBanner: React.FC<TrialEndedBannerProps> = ({ trialEndDate }) => {
  const formattedDate = useMemo(() => {
    if (!trialEndDate) {
      return null;
    }
    try {
      const date = typeof trialEndDate === 'string' ? new Date(trialEndDate) : trialEndDate;
      return format(date, 'MM/dd/yyyy');
    } catch (error) {
      console.error('Error formatting trial end date:', error);
      return 'recently';
    }
  }, [trialEndDate]);

  if (!formattedDate) {
    return null;
  }

  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <Alert
        severity="info"
        sx={{
          width: '100%',
          '& .MuiAlert-message': {
            width: '100%',
          },
        }}
      >
        <Typography variant="body1" sx={{ textAlign: 'center', fontWeight: 500 }}>
          Your trial ended on {formattedDate}
        </Typography>
      </Alert>
    </Box>
  );
};
